import { TypedDocumentNode, gql } from "@apollo/client";

interface MenuData {
  menuQuery: {
    menus: MenuInterface[];
    offer: Offer;
  };
}

export const GET_MENUS: TypedDocumentNode<MenuData, MenuVars> = gql`
  query GetMenus($countrySlug: String, $citySlug: String) {
    menuQuery(countrySlug: $countrySlug, citySlug: $citySlug) {
      menus {
        name
        linkTitle
        slug
        icon
        courses {
          slug
          name
          linkTitle
          icon
          icon_url
          accreditationUrl
          accreditationLogo
          accreditationName
          serviceTrainingDays
          isPopular
          isCertificationProgram
          isSkillBasedCourses
          modeOfTraining
        }
      }
      offer {
        name
        couponCode
        description
        discountPercentage
        startDate
        endDate
      }
    }
  }
`;
